import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=c624a69c&scoped=true&"
import script from "./Chat.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Chat.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Chat.vue?vue&type=style&index=0&id=c624a69c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c624a69c",
  null
  
)

export default component.exports